<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Technicians" title="Location Log" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
		
							<div class="col-md-12 project-list filter-sort">
								<div class="row">

									<div class="col-md-3">
										<label class="control-label">Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="date" :min="min" :max="max" value-as-string >
									</div>
									<div class="col-md-2" style="margin-top: 33px;">
										<div class="btn btn-info" @click="fetchTechnitionLog">Submit</div>
									</div>
								</div>
							</div>

							<div>
								<GMapMap
									:center="mapCenter"
									:zoom="10"
									style="width: 100%; height: 600px;"
									v-if="mapCenter"
								>
									<GMapPolyline
										v-if="travelPath.length"
										:path="travelPath"
										:options="polylineOptions"
									/>

									<GMapMarker
										v-for="(log, index) in filteredLogs"
										:key="index"
										:position="{ lat: parseFloat(log.latitude), lng: parseFloat(log.longitude) }"
										@click="setSelectedLog(log)"
										:icon="{
											url: require('@/assets/technician.png'),
											scaledSize: { width: 40, height: 40 }
										}"
									>
										<GMapInfoWindow
											v-if="selectedLog === log"
											:closeclick="true"
											@closeclick="selectedLog = null"
											>
											<div style="font-size: 14px; line-height: 1.5;">
												<span><strong>Type:</strong> {{ log.type }}</span><br>
												<span v-if="log.job_id"><strong>Job ID:</strong> {{ log.job_id || 'N/A' }}</span>
												<div><strong>Time:</strong> {{ log.date.split(' ')[1] }}</div>
												<div v-if="log.duration"><strong>Duration:</strong> {{ log.duration }}</div>
											</div>
										</GMapInfoWindow>
									</GMapMarker>

								</GMapMap>

							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
	import { get } from '@/utils/api';
	import { routes } from '@/constants/routes';
	import { onMounted, ref, getCurrentInstance, computed, nextTick } from 'vue';
	import { useRouter, useRoute } from 'vue-router';
	import Swal from '@/utils/swal';

	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const route = useRoute();
	const technician_id = route.query.id;

    const now = new Date()
    // const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // const todayStr = today.toJSON().slice(0, 10).replace(/-/g, '-')
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const todayStr = today.getFullYear() + '-' +

	String(today.getMonth() + 1).padStart(2, '0') + '-' +
	String(today.getDate()).padStart(2, '0');

    const minDate = new Date('2024-01-01')
    const date = ref(todayStr)
    const min = ref(minDate)
    const max = ref(todayStr)
    const token = ref("")

    const mapCenter = ref(null)
    const filteredLogs = ref([])
    const selectedLog = ref(null)
    const travelPath = ref([])
    const googleMaps = ref(null)

	const technician = ref({});

    const polylineOptions = ref({
        strokeColor: '#007bff',
        strokeOpacity: 1.0,
        strokeWeight: 4,
        icons: [],
    })

	const travelLogs = ref([])

    const computedTravelPath = computed(() => {
        return filteredLogs.value.map(log => ({
            lat: parseFloat(log.latitude),
            lng: parseFloat(log.longitude)
        }))
    })

    onMounted(() => {
        if (!window.google) {
            console.error("Google Maps SDK not loaded.")
        }
    })

    function setSelectedLog(log) {
        selectedLog.value = null
        nextTick(() => {
            selectedLog.value = log
        })
    }

	const fetchTechnitionLog = () => {
    
		const params = {
			technician_id: technician_id,
			date: date.value,
		}

		get(routes.TechnicianTravelLogs, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					travelLogs.value = response.data.data.location_logs;
					
					selectedLog.value = null
					filteredLogs.value = travelLogs.value.filter(log =>
						log.date.startsWith(date.value)
					)
					console.log(filteredLogs.value);
					if (filteredLogs.value.length > 0) {
						const first = filteredLogs.value[0]
						mapCenter.value = {
						lat: parseFloat(first.latitude),
						lng: parseFloat(first.longitude)
						}
					} else {
						Swal.fire('Error', 'No logs found for the selected date.', 'error');
						mapCenter.value = null
					}

					if (filteredLogs.value.length > 1) {
						travelPath.value = filteredLogs.value.map(log => ({
							lat: parseFloat(log.latitude),
							lng: parseFloat(log.longitude)
						}))

						if (window.google && window.google.maps) {
							googleMaps.value = window.google.maps

							polylineOptions.value = {
								strokeColor: '#007bff',
								strokeOpacity: 1.0,
								strokeWeight: 4,
								icons: [
								{
									icon: {
									path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
									scale: 3,
									strokeColor: '#007bff',
									},
									offset: '100%',
									repeat: '50px'
								}
								]
							}
						} else {
							console.error('Google Maps SDK not loaded yet.')
						}
					}
					
				} else {
					Swal.fire('', response.data.message || 'Error fetching data', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('', error.response.data.message.technician_id?.[0] || 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	// onMounted(() => {
	// 	fetchTechnitionLog();
	// });
</script>

